import { APP_VERSION } from './version';

let _sentry = null;

const initSentry = async () => {
  try {
    const Sentry = await import('@sentry/react');

    const dsn = "https://31059dcc3dbeb94fbf46cd166c3303fc@o4509983835815936.ingest.us.sentry.io/4511309920993280"

    if (!dsn) {
      console.warn("Sentry: DSN não configurado");
      return;
    }

    Sentry.init({
      dsn,
      environment: 'production',
      release: APP_VERSION,

      // Para habilitar coleta de IP e dados do usuário, mude para true
      sendDefaultPii: true,
      // sendDefaultPii: true,

      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,

      // Para habilitar breadcrumbs de navegação/cliques, mude para 50
      maxBreadcrumbs: 0,
      // maxBreadcrumbs: 50,

      integrations: [],
      tracePropagationTargets: [],

      // Para habilitar a API de logs do Sentry, mude para true
      enableLogs: false,
      // enableLogs: true,

      beforeSend: (event) => {
        if (event.level !== 'error') return null;

        if (event.exception?.values) {
          event.exception.values = event.exception.values.slice(0, 1);
        }

        return event;
      },

      normalizeDepth: 3,
      maxValueLength: 1000,
    });

    _sentry = Sentry;

    //Sincronizar usuário já autenticado após Sentry inicializar
    const { useUser } = await import('../store/global/useUser');
    const currentUser = useUser?.getState()?.data?.user;
    if (currentUser) setSentryUser(currentUser);

  } catch (error) {
    console.warn('⚠️ Falha ao inicializar Sentry:', error.message);
  }
};

export const setSentryUser = (user) => {
  if (!_sentry || !user) return;
  _sentry.setUser({
    id: user?.id ?? user?.uid,
    email: user?.email,
    username: user?.name ?? user?.username,
    ip_address: '{{auto}}',
  });
};

export const clearSentryUser = () => {
  if (!_sentry) return;
  _sentry.setUser(null);
};

export default initSentry;
